var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDotsVertical = function SvgDotsVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 5.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Zm-1.5 5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm0 6.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z",
    fill: "currentColor"
  })));
};

export { SvgDotsVertical as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy41IDUuNUMxMy41IDQuNjcxNTcgMTIuODI4NCA0IDEyIDRDMTEuMTcxNiA0IDEwLjUgNC42NzE1NyAxMC41IDUuNUMxMC41IDYuMzI4NDMgMTEuMTcxNiA3IDEyIDdDMTIuODI4NCA3IDEzLjUgNi4zMjg0MyAxMy41IDUuNVpNMTIgMTAuNUMxMi44Mjg0IDEwLjUgMTMuNSAxMS4xNzE2IDEzLjUgMTJDMTMuNSAxMi44Mjg0IDEyLjgyODQgMTMuNSAxMiAxMy41QzExLjE3MTYgMTMuNSAxMC41IDEyLjgyODQgMTAuNSAxMkMxMC41IDExLjE3MTYgMTEuMTcxNiAxMC41IDEyIDEwLjVaTTEyIDE3QzEyLjgyODQgMTcgMTMuNSAxNy42NzE2IDEzLjUgMTguNUMxMy41IDE5LjMyODQgMTIuODI4NCAyMCAxMiAyMEMxMS4xNzE2IDIwIDEwLjUgMTkuMzI4NCAxMC41IDE4LjVDMTAuNSAxNy42NzE2IDExLjE3MTYgMTcgMTIgMTdaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";